<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('afterSales.search_product.title') }}
      </h2>

      <div class="irinox-form after-sales p-mt-4" >
        <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6 p-xl-4">
                  <label for="model" >{{ $t('afterSales.search_product.model') }}</label>
                  <InputText id="model" v-model="filters.model" :placeholder="$t('afterSales.search_product.model_ph')" 
                    :class="{'p-invalid':v$.filters.model.$invalid && submitted}"/>
              </div>
          </div>
          <div v-if="modelsFiltered.length===0 && filters.model?.length>=3" class="empty-list p-mt-4">
            {{ $t('afterSales.search_product.empty_list') }}
          </div>
          <div v-else-if="modelsFiltered.length>0" class="model-list p-mt-4">
    
            <DataTable :value="modelsFiltered" stripedRows
                responsiveLayout="stack"
                breakpoint="960px"
                :autoLayout="true" class="after-sales-table p-mt-4"
                rowGroupMode="subheader" groupRowsBy="data.domain"
                sortMode="multiple"  :multiSortMeta="[{field: 'data.domain', order: -1}, {field: 'label', order: 1}]">
    
                <template #groupheader="slotProps">
                    <div class="domain-group-header">
                      {{ $t('afterSales.domain_'+slotProps.data.data.domain.replace(" ", "_")) }}
                    </div>
                </template>
    
                <Column field="data.domain"></Column>
    
                <Column field="label"></Column>

                <!-- <Column v-for="index in 5" :field="'data.level' + index + 'Translation'" :key="index"></Column> -->
    
                <Column field="docTreeId">
                  <template #body="slotProps">
                    <div class="p-d-flex p-ai-center after-sales-datatable-buttons p-jc-end">
                      <i class="pi pi-external-link" @click="goTo(slotProps.data.data.docTreeId)"></i>
                    </div>
                  </template>
                </Column>
    
            </DataTable>
    
          </div>
      </div>



    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('afterSales.search_product.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />


</template>

<script>
import { required, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
// import {FilterService} from 'primevue/api';

export default {
  components: { 
    IrinoxDialogDark
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      filters: { 
        model: null, 
      },
      submitted: false,
      dialog: {
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      searchProduct: 'afterSales/searchProduct',
    }),
    modelsLeaf: function() {
      // get the last 2 levels of the docTreeRaw
      let models = [];
      for(let m of this.docTreeRaw) {
        for(let lev=5; lev>=2; lev--) {
          if(m['level'+lev]) {
            let label = (m['level'+(lev-1)+'Translation'] ?? m['level'+(lev-1)]) + ' - ' + (m['level'+lev+'Translation'] ?? m['level'+lev]);
            models.push({data: m, label: label});
            break;
          }
        }
      }
      return models;
    },
    models: function() {
      // get all levels of the docTreeRaw
      let models = [];
      for(let m of this.docTreeRaw) {
        let labelParts = [];
        for(let lev=1; lev<=5; lev++) {
          if(m['level'+lev]) {
            labelParts.push(m['level'+lev+'Translation'] ?? m['level'+lev]);
          }
        }
        let label = labelParts.join(' - ');
        models.push({data: m, label: label});
      }
      return models;
    },
    modelsFiltered() {
      if(!this.filters.model || this.filters.model.length<3) {
        return [];
      }
      let filter = this.filters.model.toLowerCase();
      return this.models.filter(m => m.label.toLowerCase().includes(filter));
    }
  },
  validations() {
      return {
          filters: {
            model: {
                required,
                minLength: minLength(3),
            },
          }
      };
  },
  watch: {
  },
  created() {
  },
  mounted() { 
    if(this.docTreeRaw.length===0) {
      this.$router.push('/after-sales');
    }
    this.filters.model = this.searchProduct?.model;
  },
  unmounted() {
    this.$store.commit('afterSales/searchProductModel', {model: this.filters.model});
  },
  methods: {
    goTo(docTreeId) {
      this.$store.commit('afterSales/searchProductModel', {model: this.filters.model});
      this.$router.push('/after-sales/tree/'+docTreeId);
    },
  }
}
</script>